import dispatcher from '../dispatcher';
import popupStore from '../popup/popup.store';
import innerLinkProto from '../router/inner-link.component';

var elementProto = Object.create(HTMLAnchorElement.prototype);

var _additionalClickHanlder = function() {
	var self = this;
	var activePopup = popupStore.getData().active;

	if (self.classList.contains('active')) {
		clearTimeout(self._to);

		if (activePopup) {
			dispatcher.dispatch({
				type: 'popup:close-all',
			});
			self._to = setTimeout(function() {
				dispatcher.dispatch({
					type: 'scroll:to',
					index: 0
				});
			}, 300);
		} else {
			dispatcher.dispatch({
				type: 'scroll:to',
				position: 0
			});
		}
	} else {
		if (activePopup) {
			this._transitionType = 'menu';
		} else {
			this._transitionType = 'basic';
		}
	}
}

elementProto.createdCallback = function() {
	innerLinkProto.createdCallback.apply(this);
	this.additionalClickHanlder = _additionalClickHanlder.bind(this);
}
elementProto.attachedCallback = function() {
	this.addEventListener('click', this.additionalClickHanlder);
	innerLinkProto.attachedCallback.apply(this);
}
elementProto.detachedCallback = function() {
	innerLinkProto.detachedCallback.apply(this);
}

document.registerElement('logo-link', {
	prototype: elementProto,
	extends: 'a'
});